import { put, call, takeEvery, select } from 'redux-saga/effects';

import customerAPI from '../../api/customer';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerOrderProductsRequest({ order }) {
  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const products = yield call(customerAPI.orderInformations, order.hash, 'itens', token, siteId);

    yield put(Creators.customerOrderProductsSuccess([{ id: order.id, products, productsError: false }], order.id));
  } catch (error) {
    yield put(Creators.customerOrderProductsFailed([{ id: order.id, productsError: true }], order.id));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ORDER_PRODUCTS_REQUEST, customerOrderProductsRequest);
}
